import { jsxs as n, jsx as t } from "react/jsx-runtime";
import * as r from "react";
import { Input as l } from "../input/Input.js";
import { EyeOff as c, Eye as f } from "lucide-react";
import { Button as h } from "../button/Button.js";
import { cn as w } from "../../../lib/utils.js";
const u = r.forwardRef(({ className: e, showPasswordLabel: a = "Show password", hidePasswordLabel: o = "Hide password", ...i }, p) => {
  const [s, d] = r.useState(!1);
  return n("div", { className: "relative", children: [t(l, { type: s ? "text" : "password", className: w("pr-10", e), ref: p, ...i }), t(h, { type: "button", variant: "ghost", size: "sm", className: "absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent", onClick: () => d((m) => !m), "aria-label": s ? o : a, children: s ? t(c, { className: "h-4 w-4 text-text-secondary", "aria-hidden": "true" }) : t(f, { className: "h-4 w-4 text-text-secondary", "aria-hidden": "true" }) })] });
});
u.displayName = "PasswordInput";
export {
  u as PasswordInput
};
//# sourceMappingURL=PasswordInput.js.map
